import { iconButtonClasses } from "@mui/material";
import styled, { css } from "styled-components";

export const CarouselContainer = styled.div`
	width: 100%;
	height: 100%;
	max-width: 560px;
	overflow: hidden;
`;

export const CardCounter = styled.div`
	position: absolute;
	top: 16px;
	left: 16px;
	background-color: rgba(0, 0, 0, 0.3);
	color: white;
	padding: 6px 12px;
	border-radius: 16px;
	font-size: 14px;
	font-weight: 500;
	z-index: 20;
	backdrop-filter: blur(4px);
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
`;

export const BaseIconModal = styled.div`
	width: 40px;
	height: 40px;
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 4px;
	cursor: pointer;
	background-color: ${({ theme }) => theme.grayLight};
	z-index: 10;

	&&& {
		& .${iconButtonClasses.root} {
			width: 100%;
			height: 100%;
			padding: 0;
		}
		& .${iconButtonClasses.disabled} {
			opacity: 0.2;
			cursor: not-allowed;
		}
	}

	svg {
		width: 20px;
		height: 20px;
		fill: ${({ theme }) => theme.pantoneBlack};
	}
`;

interface IControlsProps {
	$isAbsoluteControls?: boolean;
}

export const Controls = styled.div<IControlsProps>`
	display: flex;
	justify-content: space-between;
	z-index: 999;

	${({ $isAbsoluteControls }) =>
		$isAbsoluteControls &&
		css`
			position: absolute;
			left: 0;
			padding: 0 1rem;
			width: 100%;
			top: 50%;
			transform: translateY(50%);
		`}
`;

export const CardWrapper = styled.div<{ $translate: number }>`
	display: flex;
	transition: transform 0.4s ease;
	transform: translateX(${({ $translate }) => $translate * -100}%);
	height: 100%;
`;
